/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { GetMacroTipiOnereParams } from '../schemas/getMacroTipiOnereParams.ts';
import type { MacroTipoOnereDettaglioDTO } from '../schemas/macroTipoOnereDettaglioDTO.ts';
import type { MacroTipoOnereDTO } from '../schemas/macroTipoOnereDTO.ts';
import type { MacroTipoOnereRequest } from '../schemas/macroTipoOnereRequest.ts';
import type { TipoOnereDTO } from '../schemas/tipoOnereDTO.ts';
import type { WsProblema } from '../schemas/wsProblema.ts';
import type { WsRispostaPaginataListMacroTipoOnereDettaglioDTO } from '../schemas/wsRispostaPaginataListMacroTipoOnereDettaglioDTO.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Restituisce il macro-tipo onere e i relativi tipi-onere associati
 * @summary Dettaglio MacroTipo Onere
 */
export const getMacroTipiOnereId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<MacroTipoOnereDettaglioDTO>(
    {
      url: `/framework-cfg-domande/macro-tipi-onere/${id}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetMacroTipiOnereIdQueryKey = (id: string) =>
  [`/framework-cfg-domande/macro-tipi-onere/${id}`] as const;

export const getGetMacroTipiOnereIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMacroTipiOnereId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMacroTipiOnereId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getMacroTipiOnereId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMacroTipiOnereIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMacroTipiOnereId>>
  > = ({ signal }) => getMacroTipiOnereId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetMacroTipiOnereIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMacroTipiOnereId>>
>;
export type GetMacroTipiOnereIdQueryError = ErrorType<unknown>;

/**
 * @summary Dettaglio MacroTipo Onere
 */
export const useGetMacroTipiOnereId = <
  TData = Awaited<ReturnType<typeof getMacroTipiOnereId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMacroTipiOnereId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMacroTipiOnereIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aggiorna un macro-tipo onere.
 * @summary Modifica MacroTipo Onere
 */
export const putMacroTipiOnereId = (
  id: string,
  macroTipoOnereRequest: MacroTipoOnereRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<MacroTipoOnereDTO>(
    {
      url: `/framework-cfg-domande/macro-tipi-onere/${id}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: macroTipoOnereRequest,
    },
    options,
  );
};

export const getPutMacroTipiOnereIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMacroTipiOnereId>>,
    TError,
    { id: string; data: MacroTipoOnereRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMacroTipiOnereId>>,
  TError,
  { id: string; data: MacroTipoOnereRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMacroTipiOnereId>>,
    { id: string; data: MacroTipoOnereRequest }
  > = props => {
    const { id, data } = props ?? {};

    return putMacroTipiOnereId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMacroTipiOnereIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMacroTipiOnereId>>
>;
export type PutMacroTipiOnereIdMutationBody = MacroTipoOnereRequest;
export type PutMacroTipiOnereIdMutationError = ErrorType<WsProblema>;

/**
 * @summary Modifica MacroTipo Onere
 */
export const usePutMacroTipiOnereId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMacroTipiOnereId>>,
    TError,
    { id: string; data: MacroTipoOnereRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutMacroTipiOnereIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Consente la cancellazione di un MacroTipo Onere e dei relativi tipi-onere associati. L’operazione di cancellazione è consentita solo ed esclusivamente in assenza di TipiOnere figli associati ad una Tipologia di Domanda.
 * @summary Elimina macro-tipo onere e relativi tipi-onere associati
 */
export const deleteMacroTipiOnereId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    { url: `/framework-cfg-domande/macro-tipi-onere/${id}`, method: 'delete' },
    options,
  );
};

export const getDeleteMacroTipiOnereIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMacroTipiOnereId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMacroTipiOnereId>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMacroTipiOnereId>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteMacroTipiOnereId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMacroTipiOnereIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMacroTipiOnereId>>
>;

export type DeleteMacroTipiOnereIdMutationError = ErrorType<WsProblema>;

/**
 * @summary Elimina macro-tipo onere e relativi tipi-onere associati
 */
export const useDeleteMacroTipiOnereId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMacroTipiOnereId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getDeleteMacroTipiOnereIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ottiene l'elenco dei macro-tipi onere
 * @summary Elenco MacroTipi Onere
 */
export const getMacroTipiOnere = (
  params?: GetMacroTipiOnereParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListMacroTipoOnereDettaglioDTO>(
    {
      url: `/framework-cfg-domande/macro-tipi-onere`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetMacroTipiOnereQueryKey = (
  params?: GetMacroTipiOnereParams,
) =>
  [
    `/framework-cfg-domande/macro-tipi-onere`,
    ...(params ? [params] : []),
  ] as const;

export const getGetMacroTipiOnereQueryOptions = <
  TData = Awaited<ReturnType<typeof getMacroTipiOnere>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMacroTipiOnereParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMacroTipiOnere>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getMacroTipiOnere>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMacroTipiOnereQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMacroTipiOnere>>
  > = ({ signal }) => getMacroTipiOnere(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetMacroTipiOnereQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMacroTipiOnere>>
>;
export type GetMacroTipiOnereQueryError = ErrorType<unknown>;

/**
 * @summary Elenco MacroTipi Onere
 */
export const useGetMacroTipiOnere = <
  TData = Awaited<ReturnType<typeof getMacroTipiOnere>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMacroTipiOnereParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMacroTipiOnere>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMacroTipiOnereQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Crea un nuovo macro-tipo onere e ne restituisce l'id.
 * @summary Crea MacroTipo Onere
 */
export const postMacroTipiOnere = (
  macroTipoOnereRequest: MacroTipoOnereRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-cfg-domande/macro-tipi-onere`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: macroTipoOnereRequest,
    },
    options,
  );
};

export const getPostMacroTipiOnereMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMacroTipiOnere>>,
    TError,
    { data: MacroTipoOnereRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMacroTipiOnere>>,
  TError,
  { data: MacroTipoOnereRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMacroTipiOnere>>,
    { data: MacroTipoOnereRequest }
  > = props => {
    const { data } = props ?? {};

    return postMacroTipiOnere(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMacroTipiOnereMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMacroTipiOnere>>
>;
export type PostMacroTipiOnereMutationBody = MacroTipoOnereRequest;
export type PostMacroTipiOnereMutationError = ErrorType<WsProblema>;

/**
 * @summary Crea MacroTipo Onere
 */
export const usePostMacroTipiOnere = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMacroTipiOnere>>,
    TError,
    { data: MacroTipoOnereRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostMacroTipiOnereMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postMacroTipiOnereB2B = (
  postMacroTipiOnereB2BBody: string[],
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<MacroTipoOnereDettaglioDTO[]>(
    {
      url: `/framework-cfg-domande/macro-tipi-onere/b2b`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: postMacroTipiOnereB2BBody,
    },
    options,
  );
};

export const getPostMacroTipiOnereB2BMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMacroTipiOnereB2B>>,
    TError,
    { data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMacroTipiOnereB2B>>,
  TError,
  { data: string[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMacroTipiOnereB2B>>,
    { data: string[] }
  > = props => {
    const { data } = props ?? {};

    return postMacroTipiOnereB2B(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMacroTipiOnereB2BMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMacroTipiOnereB2B>>
>;
export type PostMacroTipiOnereB2BMutationBody = string[];
export type PostMacroTipiOnereB2BMutationError = ErrorType<unknown>;

export const usePostMacroTipiOnereB2B = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMacroTipiOnereB2B>>,
    TError,
    { data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostMacroTipiOnereB2BMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ottiene l'elenco degi tipi onere associati al macro-tipo onere
 * @summary Elenco TipiOnere per macro-tipo onere
 */
export const getMacroTipiOnereIdTipiOnere = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoOnereDTO[]>(
    {
      url: `/framework-cfg-domande/macro-tipi-onere/${id}/tipi-onere`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetMacroTipiOnereIdTipiOnereQueryKey = (id: string) =>
  [`/framework-cfg-domande/macro-tipi-onere/${id}/tipi-onere`] as const;

export const getGetMacroTipiOnereIdTipiOnereQueryOptions = <
  TData = Awaited<ReturnType<typeof getMacroTipiOnereIdTipiOnere>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMacroTipiOnereIdTipiOnere>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getMacroTipiOnereIdTipiOnere>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMacroTipiOnereIdTipiOnereQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMacroTipiOnereIdTipiOnere>>
  > = ({ signal }) => getMacroTipiOnereIdTipiOnere(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetMacroTipiOnereIdTipiOnereQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMacroTipiOnereIdTipiOnere>>
>;
export type GetMacroTipiOnereIdTipiOnereQueryError = ErrorType<unknown>;

/**
 * @summary Elenco TipiOnere per macro-tipo onere
 */
export const useGetMacroTipiOnereIdTipiOnere = <
  TData = Awaited<ReturnType<typeof getMacroTipiOnereIdTipiOnere>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMacroTipiOnereIdTipiOnere>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMacroTipiOnereIdTipiOnereQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
